import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { LlmExtractionsTable } from "@/components/LlmExtractionsTable";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function LlmExtractionsPage() {
  const [searchParams] = useSearchParams();

  const [orgIdInput, setOrgIdInput] = useState(searchParams.get("organisationId") ?? "");
  const debouncedOrgId = useDebouncedValue(orgIdInput.trim());

  const [refreshKey, setRefreshKey] = useState(0);

  // Only apply the org filter once it's a full UUID - the API expects uuid format.
  const organisationId = UUID_PATTERN.test(debouncedOrgId) ? debouncedOrgId : undefined;

  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-1 text-2xl font-bold">Bill Extractions</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Cross-organisation bill-extraction cost: model, token usage, USD cost, and timing per
        extraction. Newest first. Each row links to its bill.
      </p>

      <div className="mb-4 flex flex-wrap items-center gap-3">
        <Input
          placeholder="Filter by organisation ID..."
          value={orgIdInput}
          onChange={(e) => setOrgIdInput(e.target.value)}
          aria-invalid={!!debouncedOrgId && !organisationId}
          spellCheck={false}
          autoComplete="off"
          className="w-80 font-mono text-xs"
        />
        <Button variant="outline" size="sm" onClick={() => setRefreshKey((k) => k + 1)}>
          <RefreshCw className="mr-2 size-4" />
          Refresh
        </Button>
      </div>

      <LlmExtractionsTable organisationId={organisationId} refreshKey={refreshKey} />
    </div>
  );
}
